<template>
  <LinkButton
    :tag="emitOnlyClick ? 'button' : 'nuxt-link'"
    :secondary="active"
    :to="emitOnlyClick ? undefined : url"
    :aria-label="ariaLabel"
    class="pagination-link"
    @click="emitClick"
  >
    {{ page }}
  </LinkButton>
</template>

<script>
import { LinkButton } from '@i22/td-longtail-vue-components';

export default {
  name: 'PaginationLink',
  components: { LinkButton },
  props: {
    page: {
      type: Number,
      required: true,
    },
    url: {
      type: [Object, String, Number],
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    emitOnlyClick: {
      type: Boolean,
      default: false,
    },
    ariaLabelPrefix: {
      type: String,
      default: '',
    },
    currentPageAriaLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    ariaLabel() {
      if (this.active && this.currentPageAriaLabel) {
        return this.currentPageAriaLabel;
      }
      if (this.ariaLabelPrefix) {
        return `${this.ariaLabelPrefix} ${this.page}`;
      }
      return this.page.toString();
    },
  },
  methods: {
    emitClick() {
      this.$emit('click', this.url);
    },
  },
};
</script>
